import React from "react";
import DataTable from "react-data-table-component";

const ReportBody = ({ columns, data }) => {
  return (
    <div className="report-body">
      <DataTable
        columns={columns}
        data={data}
        pagination
        highlightOnHover
        striped
        responsive
        defaultSortFieldId={1}
      />
    </div>
  );
};

export default ReportBody;
